import _ from 'lodash'
import React from 'react'
import Select from 'material-ui/Select'
import style from './style'
import PropTypes from 'prop-types'
import { FormControl } from 'material-ui/Form'
import { InputLabel } from 'material-ui/Input'
import { MenuItem } from 'material-ui/Menu'

const renderValue = label => {
  return <div style={{ textAlign: 'start' }}>{_.startCase(label)}</div>
}
const Dropdown = ({
  value,
  onChange,
  onBlur,
  options,
  meta: { error, touched },
  floatingLabelText
}) => {
  return (
    <FormControl>
      <InputLabel htmlFor='input-select-input'>{floatingLabelText}</InputLabel>
      <Select
        key='input-select'
        displayEmpty
        error={touched && error}
        onChange={onChange}
        renderValue={renderValue}
        inputProps={{
          id: 'input-select-input',
        }}
        value={value || ''}
      >
        {
          _.chain(options)
            .map((option, i) => {
              return (
                <MenuItem
                  key={option.value + i}
                  value={option.value}
                >
                  {option.label}
                </MenuItem>
              )
            })
            .flatten()
            .value()
        }
      </Select>
    </FormControl>
  )
}

Dropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  meta: PropTypes.object
}

export default Dropdown


// WEBPACK FOOTER //
// ./src/components/Fields/Dropdown/Dropdown.js